import * as React from 'react';
import classNames from 'classnames';
import Button from 'antd/es/button';
import { Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Trans } from 'react-i18next';
import ErrorBoundary from '../../ErrorBoundary';
import { useCallback } from 'react';
import styles from '../EntityManager.module.scss';
const { Text } = Typography;
function EntityFormWrap(props) {
    const Form = props.form, [formData, setFormData] = React.useState({}), [canBeSaved, setCanBeSaved] = React.useState(props.entity ? true : false), validateRef = React.useRef(null);
    const onInput = useCallback((data, canSave) => {
        setFormData(data);
        setCanBeSaved(canSave !== false);
        props.onInput(data, canSave !== false);
    }, []);
    const registerValidate = useCallback((fn) => {
        validateRef.current = fn;
    }, []);
    const onSaveClick = () => {
        if (validateRef.current && validateRef.current() === false) {
            return;
        }
        props.onSave(formData);
    };
    return (React.createElement(ErrorBoundary, null,
        React.createElement("div", { className: styles.editFormWrapper },
            React.createElement("div", { className: styles.editForm },
                React.createElement("div", { className: props.readOnly ? styles.readOnlyForm : undefined },
                    React.createElement(Form, Object.assign({ entity: props.entity, onInput: onInput, onRegisterValidate: registerValidate, error: props.error, loading: props.loading }, props.additionalProps)))),
            React.createElement("div", { className: styles.formBottom },
                React.createElement(Button, { className: classNames('big', styles.operationCancelButton), onClick: () => props.onCancel() },
                    React.createElement(Text, null,
                        React.createElement(Trans, { i18nKey: "cancel" }))),
                React.createElement(Button, { disabled: props.loading || !canBeSaved, className: classNames('big', styles.operationContinueButton), type: "primary", onClick: onSaveClick }, !props.loading ? (React.createElement("div", null, props.saveButtonText || React.createElement(Trans, { i18nKey: "save" }))) : (React.createElement(LoadingOutlined, null)))))));
}
export default EntityFormWrap;
